var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout-sidebar"},[_c('div',{staticClass:"layout-sidebar__side"},[_c('tab-list',{attrs:{"post":_vm.tab}})],1),_c('div',{staticClass:"layout-sidebar__main"},[_c('router-view',{key:_vm.$route.path})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }